import servicioBase from '@/services/servicio-base'

const servicio = {}

servicio.adeudos =  () => {
    return servicioBase.post('/saldos')
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicio.guardarIntento = function(documentos) {
    return servicioBase.post('/pagos/pago-guardar-intento', documentos)
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

servicio.pendientes = function() {
    return servicioBase.post('/pagos/pago-pendientes')
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

servicio.cancelar = function(IdPagosWebEnc) {
    return servicioBase.get('/pagos/pago-cancelar/'+IdPagosWebEnc)
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

export default servicio